import ActionCardIconLeft from './action-card-icon-left';

export default ActionCardIconLeft;
